import React, { useEffect,useSelector } from 'react';
import './../Wrapper/Wrapper.css';
import './../Banner';
import ReactHtmlParser from 'react-html-parser';

export default function Banner(props) {

  const { data }=props;

  

    return (
            <div className="row banner" style={{backgroundColor:'#'+props.custom_design.colors[5].color}}> 
                <div className="col m8 s12 center">
                    <img  src={props.logo.full_path} className="responsive-img logo" />
                </div>
                <div className="col m4 s12  hide-on-small-only">
                    <p>{ ReactHtmlParser(data.phone) }</p>
                    <p>{ ReactHtmlParser(data.email) }</p>
                    <h6 className="time_box" style={{backgroundColor:'#'+props.custom_design.colors[1].color,color:'#'+props.custom_design.colors[7].color}}>{ReactHtmlParser(data.time)}</h6>
                    <div className="link_box">
                        <a style={{color:'#'+props.custom_design.colors[8].color,borderColor:'#'+props.custom_design.colors[8].color}} className="left_link" href="/recruitment">採用情報 </a>
                        <a style={{color:'#'+props.custom_design.colors[8].color,borderColor:'#'+props.custom_design.colors[8].color}} className="left_link" href="/news">新着情報 </a>
                        <a  style={{color:'#'+props.custom_design.colors[8].color,borderColor:'#'+props.custom_design.colors[8].color}} href="http://clovermandalay.org/">送り出し機関ページ </a>
                    </div>
                </div>
            </div>
    );
}



